import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "item", "ctaLink", "prevBtn", "nextBtn"]
  static values = { count: Number, initial: { type: Number, default: 0 } }

  connect() {
    this.current = this.initialValue
    this.total = this.countValue
    this._update()

    this._touchStartX = 0
    this.element.addEventListener("touchstart", (e) => {
      this._touchStartX = e.changedTouches[0].screenX
    }, { passive: true })
    this.element.addEventListener("touchend", (e) => {
      const diff = this._touchStartX - e.changedTouches[0].screenX
      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.current < this.total - 1) this.next()
        else if (diff < 0 && this.current > 0) this.prev()
      }
    }, { passive: true })
  }

  next() {
    if (this.current >= this.total - 1) return
    this.current++
    this._update()
  }

  prev() {
    if (this.current <= 0) return
    this.current--
    this._update()
  }

  _update() {
    const items = this.itemTargets
    const gap = 12
    const itemWidth = items[0]?.offsetWidth || 220

    items.forEach((item, i) => {
      const offset = i - this.current
      this._applyItemStyle(item, offset, itemWidth, gap)
      item.dataset.offset = offset
      item.classList.toggle("tourney-showcase__item--active", offset === 0)
    })

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.style.display = this.current <= 0 ? "none" : ""
    }
    if (this.hasNextBtnTarget) {
      this.nextBtnTarget.style.display = this.current >= this.total - 1 ? "none" : ""
    }

    // Update CTA link
    if (this.hasCtaLinkTarget) {
      const link = items[this.current]?.querySelector("a")
      this.ctaLinkTarget.href = link?.href || "#"
    }
  }

  _applyItemStyle(item, offset, itemWidth, gap) {
    const absOffset = Math.abs(offset)
    const x = offset * (itemWidth + gap)
    const scale = absOffset === 0 ? 1 : absOffset === 1 ? 0.85 : 0.7
    const opacity = absOffset === 0 ? 1 : absOffset === 1 ? 0.75 : 0.4
    const brightness = absOffset === 0 ? 1 : absOffset === 1 ? 0.8 : 0.6
    const z = 10 - absOffset

    item.style.transform = `translateX(${x}px) scale(${scale})`
    item.style.opacity = opacity
    item.style.filter = `brightness(${brightness})`
    item.style.zIndex = z
  }
}
